import { CustomButton } from '@Modules/core/components';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TConsultingAuthorizationsDataTableData = {
    primaryKey: string | number,
    date: string,
    referenceNumber: string,
    authorizationNumber: string,
    merchantId: string,
    PAN: string,
    expirationDate: string,
    amount: string,
    currency: string,
    response: string,
    status: string,
    statA: string,
    //
    currencyName: string,
    merchantName: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TConsultingAuthorizationsDataTableData>()

export function getConsultingAuthorizationsDataTableColumns({ isLoading, handleEdit, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("date",
        {
            id: "date",
            header: "Date",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("referenceNumber",
        {
            id: "referenceNumber",
            header: "N. Ref",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("authorizationNumber",
        {
            id: "authorizationNumber",
            header: "N. Autorisation",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    
    columnHelper.accessor("merchantId",
        {
            id: "merchantId",
            header: "Id Commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("PAN",
        {
            id: "PAN",
            header: "PAN",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("expirationDate",
        {
            id: "expirationDate",
            header: "Date exp.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("amount",
        {
            id: "amount",
            header: "Montant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("currency",
        {
            id: "currency",
            header: "Devise",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("response",
        {
            id: "response",
            header: "Reponse",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "status",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("statA",
        {
            id: "statA",
            header: "Stat. A.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    // *********************************************
    
    columnHelper.accessor("currencyName",
        {
            id: "currencyName",
            header: "Devise",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("merchantName",
        {
            id: "merchantName",
            header: "Commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Autorisation
                        </CustomButton>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
